import type * as node from '../node'

import { ForConnection } from './for-connection'
import { ForConsumption } from './for-consumption'
import { List } from './list'

// TODO: make below js-docs not postgres specific
export class Tracker {
  /**
   * In the base statement, the current node will JOIN to these nodes
   */
  public readonly connectedBy: List<ForConnection>
  /**
   * In their base statements, these nodes will JOIN to the current node
   */
  public readonly connecting: List<ForConnection>
  /**
   * In their result statements, these nodes will JOIN in the current node
   */
  public readonly consumedBy: List<ForConsumption>
  /**
   * In the result statement, the current node will JOIN in these nodes
   */
  public readonly consuming: List<ForConsumption>

  /**
   * Contains every {@link List} in this {@link Tracker}
   */
  private readonly _lists: List[]

  constructor(node: node.Node) {
    const validConnectionNode = ForConnection.isValidNode(node)
      ? node
      : undefined
    const validConsumptionNode = ForConsumption.isValidNode(node)
      ? node
      : undefined
    this._lists = [
      (this.connectedBy = new List(validConnectionNode, 'connectedBy')),
      (this.connecting = new List(validConnectionNode, 'connecting')),
      (this.consumedBy = new List(validConsumptionNode, 'consumedBy')),
      (this.consuming = new List(validConsumptionNode, 'consuming')),
    ]
  }

  /**
   * Deletes all edges tracked by this {@link Tracker}
   *
   * __WARNING:__ this cannot be undone
   */
  public destroy(): void {
    for (const list of this._lists) {
      list.clear()
    }
  }
}
